import type { DashboardMessageId } from "./dashboard.fr";

/** Tableau de bord in Arabic. Same keys and {placeholders} as dashboard.fr.ts. */
export const dashboardAr: Record<DashboardMessageId, string> = {
  "dashboard.greeting": "مرحبًا، {name}",
  "dashboard.subtitle": "{date} · كوناكري",
  "dashboard.generatedAt": "أرقام قُرئت في {time} (بفارق يصل إلى دقيقة).",
  "dashboard.refresh": "تحديث",
  "dashboard.refreshing": "جارٍ التحديث…",
  "dashboard.loading": "جارٍ تحميل لوحة المتابعة…",
  "dashboard.loadFailed": "تعذّر تحميل لوحة المتابعة.",
  "dashboard.alertsAria": "للمعالجة الآن",
  "dashboard.alert.open": "فتح ←",
  "dashboard.alert.critical_report_open.tag": "حرج",
  "dashboard.alert.critical_report_open.text": "بلاغات حرجة مفتوحة: {count}.",
  "dashboard.alert.critical_report_open.review":
    "أشخاص موقوفون حتى قرار الفريق: {count}؛ أول مراجعة يجب أن تتم قبل {date}.",
  "dashboard.alert.suspension_review_overdue.tag": "مراجعة متأخرة",
  "dashboard.alert.suspension_review_overdue.text":
    "إيقافات تجاوزت موعد مراجعتها: {count} (الأقدم: {date}). يبقى الأشخاص موقوفين حتى قرارك.",
  "dashboard.alert.cases_past_deadline.tag": "تأخّر",
  "dashboard.alert.cases_past_deadline.text": "ملفات تجاوزت مهلة الرد الأول ({hours} س): {count}.",
  "dashboard.alert.thin_coverage.tag": "العرض",
  "dashboard.alert.thin_coverage.text":
    "{trade} في {city}: {requests} طلبات اليوم مقابل {pros} محترفين متاحين. هنا يجب التوظيف.",
  "dashboard.alert.failed_payments.tag": "المدفوعات",
  "dashboard.alert.failed_payments.text": "مدفوعات Orange Money فاشلة اليوم: {count}.",

  "dashboard.card.demand": "طلبات اليوم",
  "dashboard.card.demand.answered": "رُدّ عليها في أقل من {hours} س",
  "dashboard.card.demand.unanswered": "دون رد",
  "dashboard.card.demand.expired": "منتهية الصلاحية",
  "dashboard.card.introductions": "عمليات الربط",
  "dashboard.card.introductions.quotes": "عروض أسعار مُرسَلة",
  "dashboard.card.introductions.median": "الوقت الوسيط للرد الأول",
  "dashboard.card.introductions.cancelled": "أُلغيت قبل الربط",
  "dashboard.card.pros": "محترفون موثَّقون",
  "dashboard.card.pros.unit": "نشطون",
  "dashboard.card.pros.new": "جدد خلال 7 أيام",
  "dashboard.card.pros.waiting": "بانتظار التحقق",
  "dashboard.card.pros.suspended": "موقوفون",
  "dashboard.card.money": "الرسوم المحصَّلة",
  "dashboard.card.money.failed": "مدفوعات Orange Money فاشلة",
  "dashboard.card.money.approvals": "طلبات موافقة معلّقة",
  "dashboard.card.money.subscriptions": "اشتراكات شهرية نشطة",

  "dashboard.coverage": "التغطية حسب المهنة والبلدية",
  "dashboard.coverage.empty": "لا توجد طلبات اليوم.",
  "dashboard.coverageFoot": "بالأحمر: أقل من نصف الطلبات رُدّ عليها في الوقت. هنا يجب التوظيف.",
  "dashboard.col.trade": "المهنة",
  "dashboard.col.commune": "البلدية",
  "dashboard.col.requests": "الطلبات",
  "dashboard.col.pros": "محترفون متاحون",
  "dashboard.col.answered": "رُدّ عليها < {hours} س",

  "dashboard.queues": "قوائم الانتظار",
  "dashboard.noQueues": "لا توجد قائمة لأدوارك.",
  "dashboard.queue.late_cases": "ملفات متأخرة",
  "dashboard.queue.open_cases": "ملفات مفتوحة",
  "dashboard.queue.open_cases.meta": "غير مُسنَدة: {count}",
  "dashboard.queue.identity_verifications": "عمليات التحقق من الهوية",
  "dashboard.queue.identity_verifications.meta": "الأقدم ينتظر منذ {age}",
  "dashboard.queue.safety_reports": "بلاغات مفتوحة",
  "dashboard.queue.severity.critical": "حرجة: {count}",
  "dashboard.queue.severity.high": "عالية: {count}",
  "dashboard.queue.severity.medium": "متوسطة: {count}",
  "dashboard.queue.severity.low": "منخفضة: {count}",
  "dashboard.queue.overdue_suspension_reviews": "مراجعات إيقاف متأخرة",
  "dashboard.queue.overdue_suspension_reviews.meta": "لا يزالون موقوفين حتى القرار",
  "dashboard.queue.payment_approvals": "طلبات الموافقة",
};
